"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SttListItemText = function SttListItemText(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.ListItemText, props);
};
var _default = SttListItemText;
exports["default"] = _default;